import * as React from 'react';
import { GalleryContainer } from '../../Gallery';
import { LoadMoreButtonContainer } from '../../LoadMoreButton';
import { DesktopContentLayout } from '../../../components/DesktopLayout';
import { NewbuildingInfoDesktopContainer } from '../../NewbuildingInfo';
import { MyHomeTrap } from '../../MyHomeTrap';

export const DesktopContentViewContainer: React.FC = () => {
  return (
    <DesktopContentLayout
      newbuildingInfo={<NewbuildingInfoDesktopContainer />}
      gallery={<GalleryContainer />}
      myHomeTrap={<MyHomeTrap />}
      loadMoreButton={<LoadMoreButtonContainer />}
    />
  );
};
